import React from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import Grid from '@mui/material/Grid';
import Header from '../../Layout/Header';
import Link from '@mui/material/Link';
import { ToastContainer } from 'react-toastify';
import Typography from '@mui/material/Typography';
import { useParams } from 'react-router-dom';

import i18n from '../../i18n';

import { withStyles } from 'tss-react/mui';

function PageWithHeaderFooter({component: Component, ...props}) {
  const { classes } = props;
  const params = useParams();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <ToastContainer />
      <Header />
      <Grid container component="main" className={classes.pageContent}>
        <Component params={params} {...props} />
      </Grid>
      {_renderCopyright(classes)}
    </div>
  );
}

function _renderCopyright(classes) {
  return (
    <div className={classes.footer}>
      <Typography variant="body2" color="textSecondary" align="center">
        {' © '}
        {new Date().getFullYear()}
        {' Technologies Carecity Inc. '}
        <Link color="inherit" href={i18n.t('carecityio')} underline="hover">
          {i18n.t('allRightsReserved')}
        </Link>{' '}
      </Typography>
    </div>
  );
}

const styles = _theme => ({
  footer: {
    textAlign: 'center',
    padding: '20px',
    bottom: '0',
    height: '60px',
    width: '100%',
  },
  pageContent: {
    flexGrow: 1,
  },
  root: {
    display: 'flex',
    flexDirection: 'column',
    minHeight: '100vh',
  },
});

export default withStyles(PageWithHeaderFooter, styles);
